import React, { useState } from 'react';
import Modal from '@hubins/components/Modal';
import Input from '@hubins/components/Input';
import DecimalInput from '@hubins/components/DecimalInput';
import Button, { ButtonWrap } from '@hubins/components/Button';
import { useMiddleman } from '@hubins/middleman';
import ErrorMessage from 'components/ErrorMessage';
import __ from 'localisation';


const EditProfileUserInfoModal = ({ profile, setProfile, refetch }) => {
  const middleman = useMiddleman();

  const [position, setPosition] = useState(profile?.info?.position || '');
  const [ownershipPercentage, setOwnershipPercentage] = useState(profile?.info?.ownership_percentage || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const submit = async () => {
    setLoading(true);
    setError(false);
    const profileId = profile?.relation?.profile_id;
    const userId = profile?.relation?.user_id;
    try {
      await middleman.put(`/ql/crm/profile-user-info/${profileId}/${userId}`, {
        position,
        ownershipPercentage,
      });
      setProfile(null);
      refetch();
    } catch (error) {
      console.error(error);
      setError(true);
    }
    setLoading(false);
  };

  return (
    <Modal open={!!profile} callback={setProfile}>
      <Input label={__('role')} value={position} callback={setPosition} />
      <DecimalInput label={__('ownership_percentage')} value={ownershipPercentage} callback={setOwnershipPercentage} />
      <ButtonWrap>
        <Button className='cta' onClick={submit} iconColor='white' loading={loading}>{__('save')}</Button>
        <Button onClick={() => setProfile(null)}>{__('cancel')}</Button>
      </ButtonWrap>
      {error && <ErrorMessage text={__('common_error_validation')} showError={error} />}
    </Modal>
  );
};

export default EditProfileUserInfoModal;